<template lang="pug">
    UniversalLink(
        v-if="banner"
        trackingEventType="sitewideBanner"
        :link="url"
    )
        div(class="relative z-50 flex justify-center m-auto h-8"
        :class="backgroundColorClass"
        :style="backgroundColorStyle")
            div(class="h-full w-auto")
                Picture(v-if="!hidingPromoImages" v-bind="pictureBindings" class="max-h-8")
</template>

<script>
import getRefittedUrlMixin from '@/helpers/getRefittedUrlMixin'
import Picture from '@/components/picture'
import UniversalLink from '@/components/universalLink'
import { generateBackgroundColorClass } from '@/integrations/storyblok/helpers'

export default {
    components: {
        UniversalLink,
        Picture,
    },
    mixins: [getRefittedUrlMixin],
    props: {
        sitewideBanner: {
            type: Object,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            hidingPromoImages: false,
            timeTravelBanner: null,
        }
    },
    async fetch() {
        try {
            if (this.$route.query?.timeTravel) {
                const fetchedData = await this.$axios.$get(
                    `${this.$config.platform.apis.global}?timeTravel=${this.$route.query.timeTravel}`
                )

                if (fetchedData?.sitewideBanner) this.timeTravelBanner = fetchedData.sitewideBanner
            }
        } catch (e) {
            // Gracefully move on
        }
    },
    computed: {
        backgroundColorStyle() {
            if (
                !this.banner.content.mobileCustomBackgroundColor &&
                !this.banner.content.desktopCustomBackgroundColor
            )
                return

            if (this.$device.isMobile)
                return { backgroundColor: this.banner.content.mobileCustomBackgroundColor }

            return { backgroundColor: this.banner.content.desktopCustomBackgroundColor }
        },
        backgroundColorClass() {
            if (this.backgroundColorStyle?.backgroundColor) return

            if (this.$device.isMobile) {
                return generateBackgroundColorClass(this.banner.content.mobileBackgroundColor)
            }

            return generateBackgroundColorClass(this.banner.content.desktopBackgroundColor)
        },
        banner() {
            return this.timeTravelBanner ? this.timeTravelBanner : this.sitewideBanner
        },
        url() {
            if (this.$device.isMobile) return this.banner.content.mobileUrl

            return this.banner.content.desktopUrl
        },
        pictureBindings() {
            let desktopImage = null
            let mobileImage = null

            if (this.banner.content.desktopImage.filename.includes('.svg')) {
                mobileImage = this.$storyblok.getNormalizedAsset(
                    {
                        src: this.banner.content.mobileImage.filename,
                        width: 768,
                        height: 32,
                    },
                    768,
                    {
                        width: 768,
                        height: 32,
                    }
                )

                desktopImage = this.$storyblok.getNormalizedAsset(
                    {
                        src: this.banner.content.desktopImage.filename,
                        width: 1334,
                        height: 32,
                    },
                    1334,
                    {
                        width: 1334,
                        height: 32,
                    }
                )
            } else {
                mobileImage = this.$storyblok.getNormalizedAsset(
                    this.banner.content.mobileImage.filename,
                    768,
                    {
                        width: 768,
                        height: 32,
                    }
                )
                desktopImage = this.$storyblok.getNormalizedAsset(
                    this.banner.content.desktopImage.filename,
                    1334,
                    {
                        width: 1334,
                        height: 32,
                    }
                )
            }

            return {
                mobileSrc: mobileImage.src,
                mobileWidth: mobileImage.width,
                mobileHeight: mobileImage.height,

                desktopSrc: desktopImage.src,
                desktopWidth: desktopImage.width,
                desktopHeight: desktopImage.height,
            }
        },
    },
    mounted() {
        this.$uiEvents.$on('hidingPromoImages', (data) => (this.hidingPromoImages = data))
    },
}
</script>
